export const VIVA_EXAM_ENABLED_ASSIGNMENTS = {
  'zO0q-VpMEemgBRIM9zNZlg': {
    HAkwY: true,
    lkyf2: true,
    '4piWc': true,
    lVLTc: true,
    k8h07: true,
    Wm6gy: true,
    aNCGF: false,
    feedback: true,
  },
  '4KMdRXNDEem71BLLssHDDg': {
    R1aso: true,
    DgYPq: true,
    feedback: true,
  },
  '6hkK7ZB-EeqFGRL9LTG3fQ': {
    VzLMa: true,
    AxLaN: true,
    feedback: true,
  },
  RBeVVXNDEemLRw5PTELyHA: {
    '6Qtrr': true,
    feedback: true,
  },
  ctPgBPg_Ee6TMA7H2zB4Lw: {
    akGTo: true,
    feedback: true,
  },
  nhctqbcREe633hLyyfBA1Q: {
    rSShd: true,
    '3uF9U': true,
    feedback: true,
  },
  'jcanCUYNEe--LxKeIkG8pQ': {
    AyETM: true,
    '0e8LH': true,
    bAQEr: true,
    feedback: true,
  },
  'BYIa8AenEe-SXg6EFTZuww': {
    IaOsp: true,
    feedback: true,
  },
  'JELIEDQCEe-f9Q6oSqnk-Q': {
    kHdSc: true,
    feedback: true,
  },
  di4l_R0lEeaP7xL2JHHq4w: {
    IEblI: true,
    feedback: true,
  },
  xwI6zxKhEe26hQ4jkCdYhQ: {
    Yh4qg: true,
    feedback: true,
  },
  '7dY7cOW3Ee6PQQ5ZiTVI-w': {
    '1P66t': true,
    COm3p: true,
    feedback: true,
  },
  IW6SoocrEeusSgr_K7i0hw: {
    zbx2r: true,
    feedback: true,
  },
  LzBMzheSEeqsZg5AFVQ3Fw: {
    KjoPv: true,
    feedback: true,
  },
  'Txg_b0BdEe-9Ig7qA4dB5w': {
    cJV8N: true,
    feedback: true,
  },
  'lFwfdkYJEe--LxKeIkG8pQ': {
    '0wLMC': true,
    feedback: true,
  },
  'D9STIT9pEe-4ZAr_znWoOw': {
    '2X3zZ': true,
    feedback: true,
  },
  L8PP_uHrEe6LXgr_ym7_1Q: {
    sb48S: true,
    uRuQN: true,
    PsIVD: true,
    x0ZBy: true,
    feedback: true,
  },
  'WqrFxlW0Ee-nXw4I7PxBow': {
    Zuo99: true,
    feedback: true,
  },
  hzvuyBeREeqUEA47Cx2Qsw: {
    lULUI: true,
    feedback: true,
  },
  okATK0RyEeqm3RIgnj0Fvw: {
    '6atsa': true,
    nxyse: true,
    Q4GlL: true,
    feedback: true,
  },
  slGWLCoeEe2RlwpDo6cljw: {
    fdyAa: true,
    feedback: true,
  },
  'oI-PtbBeEeytqw64hz8ZCw': {
    pm5WB: true,
    feedback: true,
  },
} as const;
